/* 
 * SlideTransition.js
 * Created on 7-apr-2017
 * @author Swen Meeuwes for &ranj
 */

import AnimationOptions from "../AnimationOptions";
import AnimationFactory from "../AnimationFactory";

export default class SlideTransition {
    constructor(type) {
        this.type = type;
    };

    animate(screenNavigator, screen, animationOptions) {
        return new Promise(function (resolve, reject) {
            // If no animation options are specified, use the default animation options
            if (animationOptions === undefined)
                animationOptions = new AnimationOptions();

            var screenStartPosition = { x: 0, y: 0 };
            var screenDestination = { x: 0, y: 0 };

            switch (this.type) {
                case AnimationFactory.SLIDE_IN_FROM_LEFT:
                    screenStartPosition.x = -screenNavigator.getScreenWidth();
                    break;
                case AnimationFactory.SLIDE_IN_FROM_RIGHT:
                    screenStartPosition.x = screenNavigator.getScreenWidth();
                    break;
                case AnimationFactory.SLIDE_IN_FROM_TOP:
                    screenStartPosition.y = -screenNavigator.getScreenHeight();
                    break;
                case AnimationFactory.SLIDE_IN_FROM_BOTTOM:
                    screenStartPosition.y = screenNavigator.getScreenHeight();
                    break;
                case AnimationFactory.SLIDE_OUT_TO_LEFT:
                    screenDestination.x = -screenNavigator.getScreenWidth();
                    break;
                case AnimationFactory.SLIDE_OUT_TO_RIGHT:
                    screenDestination.x = screenNavigator.getScreenWidth();
                    break;
                case AnimationFactory.SLIDE_OUT_TO_TOP:
                    screenDestination.y = -screenNavigator.getScreenHeight();
                    break;
                case AnimationFactory.SLIDE_OUT_TO_BOTTOM:
                    screenDestination.y = screenNavigator.getScreenHeight();
                    break;
                default:
                    // Log warning
                    break;
            }

            // Alter the screen position state to the start position of the animation
            screen.set(screenStartPosition);

            // Execute the tween with the given animation options
            createjs.Tween
                .get(screen)
                .wait(animationOptions.delay)
                .to(screenDestination, animationOptions.duration, animationOptions.ease)
                .call(function () {
                    // Handle callbacks in animation options
                    if (animationOptions.callbacks)
                        for (var i = 0; i < animationOptions.callbacks.length; i++) {
                            animationOptions.callbacks[i].call(this);
                        }
                    resolve();
                }.bind(this));
        }.bind(this));
    };
}